import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import Link from 'next/link'
import styles from './BottomNavigation.module.scss'
import Box from '@/components/UI/box/Box'
import {
  defaultLinks,
  guestLinks,
  hostLinks,
} from '@/components/layout/reusable/links'
import Typography from '@/components/UI/typography/Typography'
import { useOpenLoginModal } from '@/hooks/useOpenLoginModal'

const BottomNavigation = () => {
  const router = useRouter()
  const userInfo = useSelector(state => state.bootstrapData?.data?.user_info)
  const { setLoginDrawerState } = useOpenLoginModal()

  const links = useMemo(() => {
    if (userInfo?.uid) {
      if (userInfo?.is_host) return hostLinks
      return guestLinks
    } else {
      return defaultLinks
    }
  }, [userInfo?.uid, userInfo?.is_host])

  const clickHandler = (e, item) => {
    if (item.isLogin && !userInfo?.uid) {
      e.preventDefault()
      if (item.link === '/login') {
        setLoginDrawerState({ open: true })
      } else if (item.link === '/bookmarks') {
        setLoginDrawerState({
          open: true,
          message:
            'برای مشاهده علاقه‌مندی‌ها ابتدا باید وارد حساب کاربری خود شوید.',
          callback: () => {
            setLoginDrawerState({ open: false })
            router.push('/bookmarks')
          },
        })
      }
    }
    if (item.link === '/' && router.asPath === '/') {
      e.preventDefault()
    }
  }

  return (
    <Box className={styles['container']}>
      {links?.map((item, index) => {
        const isActive =
          router.asPath?.split('?')[0] === item.link ||
          (item.link !== '/' &&
            router.asPath?.split('?')[0]?.startsWith(item.link))
        return (
          <Link
            onClick={e => clickHandler(e, item)}
            key={'NAV_ITEM_' + index}
            href={item.link}
            className={`${styles['nav-item']} ${isActive ? styles['active'] : ''}`}
          >
            <Box className={styles['icon-container']}>{item.icon()}</Box>
            <Typography
              variant={'bodyS_Bold'}
              color={isActive ? 'primary_main' : 'neutral_main'}
            >
              {item.title}
            </Typography>
          </Link>
        )
      })}
    </Box>
  )
}

export default BottomNavigation
